const defaultBadge = "/default-user-badge.png";

export function getBadgeImagePath(badgeAvatarId?: string | number | null): string {
  if (!badgeAvatarId) return defaultBadge;

  const badgeId = badgeAvatarId.toString();

  return `/badges/${badgeId}.png`;
}
